export enum ObjectType {
	ROAD = "road",
	FLAT_GROUND = "flat_ground",
	TRENCH = "trench",
	SOLID_MESH = "solid_mesh",
	FOUNDATION_EXCAVATION = "foundation_excavation",
}

/**
 * Cross section data from database
 */
export interface ICrossSection {
	cross_section_id?: number;
	left_side_width: number;
	right_side_width: number;
	station_interval: number;
	sampling_size: number;
}

export interface ICrossSectionSettings {
	id?: number;
	leftWidth: number;
	rightWidth: number;
	interpolationPitch: number;
	samplingSize: number;
}

/**
 * Base interface for all objects
 * It is saved in the server as json
 */
export interface IObjectData {
	type: ObjectType;
	id: string;
	md5: string;
	name: string;
	associatedTerrain: {
		id: number;
		terrainType: string;
	};
}

export interface IObject extends IObjectData {
	isShow: boolean;
	isOpen: boolean;
	isLoaded: boolean;

	setVisibility(visible: boolean): Promise<boolean>;

	update<T>(data: T, updateInViewer?: boolean): Promise<void>;
	startEdit(): void;
	endEdit(): Promise<void>;
	deleteObject(): void;
	getGeometry();

	fitToView(): void;
	toJSON(): Promise<any>;
	toDuplicateJSON(): Promise<any>;
}
